import { CUSTOM_TABLE_FIELDS } from './custom-table-fields';

export const CUSTOM_TABLE_CONFIG = {
    displayedFields: [],
    tableFieldGroups: CUSTOM_TABLE_FIELDS,
    accordionItems: {},
    descriptionShowing: ''
};
